export enum MarkerEntityType {
  PrimaryMarker = "primaryMarker",
  SecondaryMarker = "secondaryMarker",
  Tooltip = "tooltip",
}
